import React, {useEffect} from 'react';
import Navigation from "./Navigation";


function Companies() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="sub-banner-section-outer">
                <Navigation/>

                <section className="sub-banner-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="sub-banner-text">
                                    <h1 className="text-white mb-lg-4 mb-3">Marketing Partners</h1>
                                    <div className="breadcrum">
                                        <span className="font-weight-normal d-inline-block text-white">Home&nbsp;/&nbsp;&nbsp;</span>
                                        <span
                                            className="breadcrum-active font-weight-normal d-inline-block text-white">Marketing Partners</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section className="about-service-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12">
                            <div className="about-service-section-img-content position-relative wow bounceIn"
                                 data-wow-duration="2s">
                                <figure className="about-service-section-shape-img-2 mb-0 position-absolute">
                                    <img className="img-fluid"
                                         src="assets/images/about-service-section-shape-img-2.png" alt=""/>
                                </figure>
                                <figure className="about-service-section-main-img mb-0 position-relative">
                                    <img className="img-fluid"
                                         src="assets/images/about-service-section-main-img.png" alt=""/>
                                </figure>
                                <div className="counter-box position-absolute">
                                    <figure className="plus-icon float-left mb-0">
                                        <img className="img-fluid" src="assets/images/client-icon.png" alt=""/>
                                    </figure>
                                    <span className="number count d-inline-block">1675</span>
                                    <span className="suffix d-inline-block">+</span>
                                    <span className="customer d-block">Trusted Clients</span>
                                </div>
                                <figure className="about-service-section-shape-img-3 mb-0 position-absolute">
                                    <img className="img-fluid"
                                         src="assets/images/about-service-section-shape-img-3.png" alt=""/>
                                </figure>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12">
                            <div className="about-service-section-text position-relative">
                                <figure className="about-service-section-shape-img-1 mb-0 position-absolute">
                                    <img className="img-fluid"
                                         src="assets/images/about-service-section-shape-img-1.png" alt=""/>
                                </figure>
                                <h2 className="mb-lg-4 mb-md-3 mb-2">Best Call Center Service For Your Business</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscinge lit sed do eiusm tempor
                                    incididunt ut labore.</p>
                                <div className="row">
                                    <div className="col-lg-5 col-md-6 col-sm-6 col-6">
                                        <div className="about-service-section-listing-outer">
                                            <ul className="about-service-section-listing p-0 m-0">
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Safe & Trusted
                                                </li>
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Fast Response
                                                </li>
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Improve Speech
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6 col-sm-6 col-6">
                                        <div className="about-service-section-listing-outer">
                                            <ul className="about-service-section-listing p-0 m-0">
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Call Notification
                                                </li>
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Call Recording
                                                </li>
                                                <li className="list-unstyled"><i
                                                    className="fal fa-check-circle"></i>Report Analytics
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col"></div>
                                </div>
                                <div className="progress-bar-outer position-relative">
                                    <span className="d-block font-weight-normal">Communication</span>
                                    <div className="progress-bar">
                                        <div className="bar" data-size="90">
                                            <span className="perc"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-bar-outer position-relative">
                                    <span className="d-block font-weight-normal">Chat Support</span>
                                    <div className="progress-bar">
                                        <div className="bar variation-1" data-size="75">
                                            <span className="perc"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="about-service-section-btn-outer d-lg-block d-none">
                                    <a className="d-inline-block hover-effect" href="#">More About Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Companies;